import React, { useState } from 'react';
import lodashDebounce from 'lodash/debounce';
import Autosuggest from 'react-autosuggest';

import useDispatch from 'client/hooks/useDispatch';
import emptyFunction from 'common/util/emptyFunction';
import requestUtilityApi from 'client/actions/requestUtilityApi';

import {
  UTILITY_ACTIVATION_STATUS_COMPLETED,
  UTILITY_ACTIVATION_STATUS_MISSING_PROVIDER,
  UTILITY_ACTIVATION_STATUS_PENDING,
} from 'common/utility/constants';
import { SR_API_ACTION_UTILITY_ACTIVATION_GET_LIST } from 'api/utilityActionTypes';

const SrFormFieldActivationAutoComplete = ({
  value,
  formField,
  setFieldValue,
  onSuggestionSelected,
  textInputFieldAttributes = {},
}) => {
  const [activationMatches, setActivationMatches] = useState([]);
  const [keyMapActivations, setKeyMapActivations] = useState({});
  const [shouldRenderSuggestions, setShouldRenderSuggestions] = useState(false);

  const dispatch = useDispatch();

  const searchAddress = (newValue) => {
    if (!newValue) {
      return;
    }

    dispatch(requestUtilityApi, {
      queryId: `${formField.id}_${newValue}`,
      action: SR_API_ACTION_UTILITY_ACTIVATION_GET_LIST,
      payload: {
        status: [
          UTILITY_ACTIVATION_STATUS_PENDING,
          UTILITY_ACTIVATION_STATUS_MISSING_PROVIDER,
          UTILITY_ACTIVATION_STATUS_COMPLETED,
        ],
        fuzzySearch: newValue,
        limit: 5,
      },
    })
      .then((autocompletePredictions) => {
        if (!autocompletePredictions) {
          return setActivationMatches([]);
        }

        setKeyMapActivations(
          autocompletePredictions.reduce((acc, activation) => {
            const key = parseSuggestion(activation);
            acc[key] = activation;
            return acc;
          }, {}),
        );

        setActivationMatches(autocompletePredictions.map(parseSuggestion));
      })
      .catch(() => {
        setActivationMatches([]);
      });
  };

  const debounceSearchAddress = lodashDebounce(searchAddress, 200);

  const parseSuggestion = ({ partner, user, address }) => {
    return `${partner.name} - ${user.firstName} ${user.lastName} - ${address.streetDisplay}`;
  };

  return (
    <Autosuggest
      suggestions={activationMatches}
      onSuggestionsClearRequested={emptyFunction}
      onSuggestionsFetchRequested={emptyFunction}
      getSuggestionValue={(suggestion) => suggestion}
      renderSuggestion={(suggestion) => suggestion}
      shouldRenderSuggestions={() => shouldRenderSuggestions}
      onSuggestionSelected={(event, { suggestion }) => {
        setActivationMatches([]);
        setFieldValue(suggestion);
        setShouldRenderSuggestions(false);

        if (onSuggestionSelected) {
          onSuggestionSelected(keyMapActivations[suggestion]);
        }
      }}
      inputProps={{
        ...textInputFieldAttributes,
        choices: activationMatches,
        autoComplete: 'off',
        value: value || '',
        onChange: (event, { newValue }) => {
          setFieldValue(newValue);
          debounceSearchAddress(newValue);
          setShouldRenderSuggestions(true);
        },
      }}
    />
  );
};

export default SrFormFieldActivationAutoComplete;
